export default {
  namespaced: true,
  state: {
    open: false,
    rooms: 0,
    type: ''
  },
  mutations: {
    OPEN (state) {
      state.open = true
    },
    CLOSE (state) {
      state.open = false
    },
    SET_ROOMS (state, payload) {
      state.rooms = payload
    },
    SET_TYPE (state, payload) {
      state.type = payload
    }
  },
  actions: {
    open ({ commit }, { rooms = 0, type = '' }) {
      commit('SET_ROOMS', rooms)
      commit('SET_TYPE', type)
      commit('OPEN')
    }
  },
  modules: {
  }
}
